/**
 * Reloads after 3 hours of page time, and 15 miniutes of idle time, after the page becomes non idle.
 */

jQuery(document).ready(function ($) {
    var reloadTimer;
    var idleTimer;
    var inactivityPeriod = 900000; // 15 minutes in milliseconds
    var threeHours = 10800000; // 3 hours in milliseconds

    // Function to reload the page
    function reloadPage() {
        window.location.reload();
    }

    // Resets the idle timer after user activity is detected
    function resetIdleTimer() {
        clearTimeout(idleTimer);
        idleTimer = setTimeout(reloadPage, inactivityPeriod);
    }

    // Start the three-hour timer
    setTimeout(function () {
        // After three hours, start monitoring for user activity
        $(document).on('mousemove scroll', function () {
            resetIdleTimer(); // Reset the 15-minute timer on user activity
        });

        // Start the 15-minute idle timer
        resetIdleTimer();
    }, threeHours);
});
